import { Skeleton } from '@lanekassen/ui';
import { startSjekkForInaktivitetUtenDynamicImport } from '@modulis/inaktivitet';
import { extractLocaleCodeFromUrl } from '../hooks/currentLangauge';
import NoeGikkGalt from '../components/NoeGikkGalt';
import { useDUQuery } from '../hooks/queries';
import { LoginContext } from './loginContext';

export function LoginContextProvider({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading, isError } = useDUQuery();

  if (isLoading) {
    return <Skeleton width="100%" height="200px" />;
  }

  if (!user?.isAuthenticated) {
    const returnUrl = encodeURIComponent(window.location.pathname);
    window.location.replace(
      `/du/logger_inn?ReturnUrl=${returnUrl}&culture=${extractLocaleCodeFromUrl(window.location.href)}`,
    );
    return null;
  }

  if (isError) {
    return <NoeGikkGalt />;
  }

  // Kommer denne til å kjøre på refetch for useDUQuery? Er ikke så farlig?
  startSjekkForInaktivitetUtenDynamicImport();
  return <LoginContext value={user}>{children}</LoginContext>;
}
